/**
 * Dualshock mapping
 */
module.exports = {
    padID: 'Dualshock',
    padType: 'Sony',
    gamepadMapping: {
        RC_S: 0,
        RC_E: 1,
        RC_W: 2,
        RC_N: 3,
        START: 9, // Options
        SELECT: 8, // Share
        LB: 4,
        RB: 5,
        LT: 6,
        RT: 7,
        LS: 10,
        RS: 11,
        LC_N: 12,
        LC_S: 13,
        LC_W: 14,
        LC_E: 15,
        MENU: 16,
        TOUCH: 17
    },
}